<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <NowBoarding showHelloPlane="true" />
        <h3>Flight Passengers List</h3>
        <v-col class="mb-4">
          <v-data-table
            hide-default-footer
            :headers="headers"
            :items="passengers"
            :items-per-page="5"
            class="elevation-1"
            disable-pagination
          >
          </v-data-table>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
h3{
  text-align: left;
  margin-left: 20px; 
}
</style>

<style>
tr:nth-of-type(2n){
  background: lightblue;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  background: black;
  color: white !important;
  font-size: 1.1rem;
}
</style>

<script>
import NowBoarding from "../components/NowBoarding.vue";

export default {
  name: "Table",
  components: { NowBoarding },
  data: () => ({
    headers: [
      { text: "Passengers", align: "start", sortable: false, value: "name" },
      { text: "Airline", value: "airline" },
      { text: "Gate", value: "gate" },
      { text: "Flight", value: "flight" },
      { text: "Status", value: "schedule" },
    ],
    dialog: false,
    passengers: [],
    editedIndex: -1,
    editedPassenger: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    timer: '',
  }),
  
  created() {
    const appBar = document.querySelectorAll('.v-app-bar')[0];
    if(this.$route.name == "Table") appBar.style.display = "none";
    this.timer = setInterval(this.getPassengers, 2000); // Set interval to update passengers
    this.getPassengers(); // Initial data load
    this.initialize(); // Initialize default state
  },
  
  methods: {
    // Retrieve passengers data from localStorage
    getPassengers() {
      const storedPassengers = localStorage.getItem('passengers');
      if (storedPassengers) {
        this.passengers = JSON.parse(storedPassengers); // Parse the JSON string into an object
      } else {
        this.initialize(); // Initialize if no data in localStorage
      }
    },
    
    beforeDestroy () {
      clearInterval(this.timer); // Clear the interval on destroy
    },
    
    // Initialize default passenger data if not found
    initialize() {
      this.passengers = [
        {
          name: "No passengers at this time!",
          schedule: 'Waiting..',
          gate: 0,
          airline: '',
          flight: ''
        },
      ];
    },
    
    // You can add more methods to handle actions like adding, editing, or deleting passengers
  },
};
</script>

